<template>
  <div class="smooth">
    <div id="js-smooth" class="smooth_container">
      <button class="smooth_container_item" @click="handleSmoothScroll()">
        <font-awesome-icon icon="arrow-up" size="2x" />
      </button>
    </div>
  </div>
</template>


<script>
import jQuery from 'jquery'
const $ = jQuery
$(function () {
  // $(window).height()だとIOSがうまく動かない
  $(window).scroll(() => {
    // スクロールした時のfadeInさせる
    if ($(this).scrollTop() > 1) {
      $('#js-smooth').fadeIn('fast')
    } else {
      $('#js-smooth').fadeOut('fast')
    }

    $('#js-smooth').css({
      position: 'fixed',
      bottom: '20px',
      right: '20px',
    })
  })
})
export default {
  methods: {
    handleSmoothScroll() {
      this.$smoothScroll({
        scrollTo: document.querySelector('#body'),
        duration: 400,
        offset: -50,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.smooth {
  position: relative;
  z-index: 1;
  &.child {
    .smooth_container {
      border: 3px solid #faa5a5;
      &_item {
        svg {
          color: #faa5a5;
        }
      }
    }
  }
  &_container {
    display: none;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 3px solid #3ACCCC;
    &_item {
      width: 100%;
      height: 100%;
      font-size: 16px;
      font-weight: bold;
      background: #fff;
      border-radius: 50%;
      border: none;
      outline: none;
      svg {
        width: 20px;
        color: #3ACCCC;
      }
    }
  }
}
</style>

